define('rest/search',["http", "./utils", "security"], function (http, utils, security) {
    "use strict";

    var queryParamsNames = [
        "typeahead", "limit", "offset", "countrySet", "lat", "lon",
        "radius", "topLeft", "btmRight", "idxSet", "maxFuzzyLevel", "geometryList"
    ];

    return {
        search: function (options, callback) {
            var pathParams = {};
            var queryParams = {};

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey("services/search"));

            // get required query statement
            pathParams.query = utils.required(options.query, "Missing query statement in Search service");
            pathParams.type = utils.required(options.type, "Missing type definition in Search service");

            // look for optional passed params and set them if they are not undefined
            utils.extractQueryParams(options, queryParams, queryParamsNames);

            var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
            var serviceUrl = utils.or(options.serviceUrl, "search/2/{type}/{query}.{contentType}");
            http.get({
                url: baseUrl + serviceUrl,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                callbackParam: "callback",
                fail: options.fail
            });
        }
    };
});
